<template>
    <div id="RequestsFilter" class="pb-10">
        <v-expansion-panels flat>
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" hide-actions>
                    <template v-slot:default="{ open }">
                        <div class="d-flex align-center">
                            <div class="text-subtitle-1 font-weight-bold gray--text">Фильтр</div>
                            <v-icon color="gray" v-if="open">arrow_drop_up</v-icon>
                            <v-icon color="gray" v-else>arrow_drop_down</v-icon>
                        </div>
                    </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="v-row">
                    <!-- Статусы -->
                    <div class="px-3">
                        <div class="mb-2">Статус заявки:</div>
                        <v-row dense>
                            <v-col v-for="opt in statusOptions" :key="opt.value" cols="12" sm="3" md="2">
                                <v-checkbox v-model="statuses" :label="opt.label" :value="opt.value" color="gray" hide-details dense />
                            </v-col>
                        </v-row>
                    </div>

                    <v-row class="px-3">
                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                label="№ договора"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="contracts"
                                item-text="contract_number"
                                item-value="contract_rid"
                                v-model="filter.contract_rid"
                                no-data-text="Нет договоров"
                            />
                        </v-col>

                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                label="Исполнитель"
                                color="gray"
                                outlined
                                dense
                                clearable
                                :items="executors"
                                item-text="title"
                                item-value="record_id"
                                v-model="filter.exec_user_rid"
                                no-data-text="Нет исполнителей"
                            />
                        </v-col>
                    </v-row>

                    <div class="px-3 pb-4">
                        <v-btn color="white" outlined @click="resetFilter" class="mr-4 gray--text">Сбросить</v-btn>
                        <v-btn color="gray" class="white--text" @click="applyFilter">Применить</v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    name: 'RequestsFilter',
    props: {
        filterModel: { type: Object, required: true },
        contracts: { type: Array, default: () => [] },
        contractsLoading: { type: Boolean, default: false },
        objects: { type: Array, default: () => [] },
        executors: { type: Array, default: () => [] }
    },
    mounted() {},
    emits: ['update:filterModel', 'applyFilter', 'resetFilter'],
    data() {
        return {
            statusOptions: [
                { label: 'В очереди', value: 'in_queue' },
                { label: 'В обработке', value: 'in_progress' },
                { label: 'Исполнена', value: 'executed' },
                { label: 'Возвращена на доработку', value: 'returned' },
                { label: 'Отменена', value: 'canceled' }
            ]
        };
    },
    computed: {
        filter: {
            get() {
                return this.filterModel;
            },
            set(value) {
                this.$emit('update:filterModel', value);
            }
        },

        statuses: {
            get() {
                return Array.isArray(this.filter.statuses) ? this.filter.statuses : [];
            },
            set(val) {
                const next = { ...this.filter, statuses: val };
                this.$emit('update:filterModel', next);
            }
        }
    },
    watch: {},
    methods: {
        applyFilter() {
            this.$emit('applyFilter');
        },
        resetFilter() {
            this.$emit('resetFilter');
        }
    }
};
</script>

<style>
#PrescriptionFilter .v-expansion-panel-content__wrap {
    padding: 0;
}
</style>
